export default "__VITE_ASSET__DGv2n$qO__"